import React from 'react';
import { useDisclosure } from '@chakra-ui/react';
import { ChatContainerBaseConfig } from '../base';
import { ComposerController } from './composerInterface';
import { ComposerContainerProps } from './composerProps';
import { useForm } from 'react-hook-form';
import { ComposerStateValues } from './composerModel';
import { ThreadContextItem } from '@varos/assistant-sdk';

export function createComposerContainer(
    config: ChatContainerBaseConfig,
    controller: ComposerController
): React.FC<ComposerContainerProps> {
    const {
        context: { useContext },
    } = config;

    return ({ as: View, ...containerProps }) => {
        const context = useContext();
        const optionDisclosure = useDisclosure();
        const contextDisclosure = useDisclosure();

        // Use controlled props or fallback to internal state
        const contextItems = containerProps.context || [];

        const form = useForm<ComposerStateValues>({
            defaultValues: {
                text: '',
            },
        });
        const values = form.watch();
        const props = controller.useProps(context, {
            disclosure: {
                option: optionDisclosure,
                context: contextDisclosure,
            },
            form: {
                id: 'composer',
                form: form,
                onSubmit(values) {
                    optionDisclosure.onClose();
                    contextDisclosure.onClose();
                    form.reset(); // Reset form optimistically
                    containerProps.onSubmit(values);
                },
            },
            field: {
                text: {
                    value: values.text,
                    placeholder: containerProps.placeholder,
                    onChange(value) {
                        form.setValue('text', value, { shouldDirty: true });
                    },
                },
            },
            context: {
                form: {
                    value: contextItems,
                    onChange: containerProps.onContextChange,
                    onClose: contextDisclosure.onClose,
                },
            },
        });
        return <View {...props} />;
    };
}
